import Image from "next/image";

/**
 * Interface representing the props for the auth page header.
 * @interface IAuthHeaderProps
 * @property {string} logoAlt: Alt text for the logo image.
 * @property {string} logoAriaLabel: Screen-reader label describing the logo link.
 * @property {string} logoHref: External URL the logo links to.
 */
interface IAuthHeaderProps {
  logoAlt: string;
  logoAriaLabel: string;
  logoHref: string;
}

const AuthHeader = ({ logoAlt, logoAriaLabel, logoHref }: IAuthHeaderProps) => (
  <header className="flex items-center justify-between">
    <a
      href={logoHref}
      className="flex items-center rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-dines-green"
      aria-label={logoAriaLabel}
    >
      <Image
        src="/dines-logo-white.png"
        alt={logoAlt}
        width={120}
        height={28}
        className="h-7 w-auto"
        priority
      />
    </a>
  </header>
);

export default AuthHeader;
